/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 24 2023
 **/

import { useQueries } from "@tanstack/react-query";
import { useGroup, useSpace } from "@/frameworks/core/API";

const SIZE_OF_RECOMMEND_SPACES = 4;
const SIZE_OF_RECOMMEND_GROUPS = 3;

export default function useRecommendedGroupAndSpace({ enabled }: { enabled?: boolean }) {
	const spaceAPI = useSpace();
	const groupAPI = useGroup();

	return useQueries({
		queries: [
			{
				queryKey: ["recommended_space"],
				queryFn: () => spaceAPI.recommends.execute({ page: 0, size: SIZE_OF_RECOMMEND_SPACES }),
				refetchOnWindowFocus: false,
				retry: false,
				enabled
			},
			{
				queryKey: ["recommended_groups"],
				queryFn: () => groupAPI.recommends.execute({ page: 0, size: SIZE_OF_RECOMMEND_GROUPS }),
				refetchOnWindowFocus: false,
				retry: false,
				enabled
			}
		]
	});
}
